export default "__VITE_ASSET__CBRzRtBq__"